<script setup>
  import IcPrev from "@/assets/images/ic_arrow_prev.png";
  import IcNext from "@/assets/images/ic_arrow_next.png";
</script>

<template>
  <n-pagination class="ui-pagination" v-bind="$attrs">
    <slot />
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template #prev>
      <n-flex align="center" :size="0" class="px-2"
        ><img :src="IcPrev" class="h-5 w-5" /><span>이전</span></n-flex
      >
    </template>
    <template #next>
      <n-flex align="center" :size="0" class="px-2"
        ><span>다음</span><img :src="IcNext" class="h-5 w-5" /></n-flex
    ></template>
  </n-pagination>
</template>

<style lang="scss">
  .ui-pagination,
  .n-data-table.ui-data-table .n-data-table__pagination {
    margin-top: 2rem;
    align-items: center;
    justify-content: center;
    .n-pagination-item {
      font-weight: 500;
      &.n-pagination-item--active {
        font-weight: 700;
      }
      &.n-pagination-item--disabled {
        opacity: 0.4;
      }
      &:not(&:first-of-type, &:last-of-type, &.n-pagination-item--active) {
        &:hover {
          background: var(--smoe-gray-200);
        }
      }
    }
  }
</style>
